<template>
  <div class="iframe-container" :style="containerStyle">
    <div style="height: 6000px;">
      <iframe
        class="results-frame"
        :src="embedUrl"
        frameborder="0"
        allow="accelerometer ; clipboard-write; encrypted-media"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  name: 'PesisTuloksetEmbed',

  computed: {
    ...mapGetters('videos', ['video']),

    embedUrl() {
      if (!this.video?.external_service_id) return '';
      return `https://www.pesistulokset.fi/ottelut/${this.video.external_service_id}`;
    },

    containerStyle() {
      return {
        position: 'relative',
        height: this.$vuetify.breakpoint.mobile ? '90%' : 'calc(100% - 53px)'
      };
    }
  }
};
</script>

<style scoped>
.iframe-container {
  overflow: scroll;
}

.results-frame {
  width: 100%;
  height: 100%;
  border: none;
}
</style>